/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 * @author    Afternet <info@afternet.gr>
 * @copyright 2022 Afternet
 * @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */

import React from 'react';
import {ReactComponent as Arrow} from "../assets/img/icons/subscribe-arrow.svg";
import LogoPng from "../assets/img/AutoRec-Logo.png";
import {ReactComponent as Logo} from "../assets/img/logo.svg";
import {Link, NavLink} from "react-router-dom";
import {useTranslation} from "react-i18next";
import CookieBot from "react-cookiebot";

const Footer = () => {

    let newDate = new Date();
    let year = newDate.getFullYear();
    const { t, i18n } = useTranslation();

    return (
        <footer className='footer'>
            <div className='container'>

                <div className='footer-signup'>
                    <div className='footer-signup__wrap'>
                        <div className='footer-signup__inner'>
                            <div className='row align-items-center justify-content-center'>
                                <div className='col-auto'><div className='footer-signup__title'>{t('home.sign')}</div></div>
                                <div className='col-auto'><div className='footer-signup__text'>{t('home.join')}</div></div>
                                <div className='col-auto'><Link to={`/${i18n.language}/register`} className="btn btn-join-now" type="button">{t('home.joinNow')} <Arrow/></Link></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='footer-main'>
                    <div className='row'>
                        <div className='col-auto footer-main__col'>

                            <div className='footer-about'>
                                <div className='footer-title'>{t('footer.about')}</div>
                                <div className='footer-text'>{t('footer.description')}</div>
                            </div>

                        </div>
                        <div className='col-auto footer-main__col'>

                            <div className='footer-links'>
                                <div className='footer-title'>{t('footer.quickLinks')}</div>
                                <ul>
                                    <li><NavLink to={`/${i18n.language}/login`} >{t('footer.login')}</NavLink></li>
                                    <li><NavLink to={`/${i18n.language}/how-it-works`} >{t('header.howitworksLink')}</NavLink></li>
                                    <li><NavLink to={`/${i18n.language}/faq`} >{t('footer.faq')}</NavLink></li>
                                    {/*<li><NavLink to={`/${i18n.language}/pricing`} >{t('footer.pricing')}</NavLink></li>*/}
                                    {/*<li><NavLink to={`/${i18n.language}/imprint`} >{t('imprint.title')}</NavLink></li>*/}
                                    <li><NavLink to={`/${i18n.language}/terms`} >{t('footer.terms')}</NavLink></li>
                                    {/*<li><NavLink to={`/${i18n.language}/ads-policy`} >{t('adsPolicy.title')}</NavLink></li>*/}
                                    <li><NavLink to={`/${i18n.language}/privacy-policy`} >{t('footer.privacy')}</NavLink></li>
                                    {/*<li><NavLink to={`/${i18n.language}/cookie-policy`}>Cookie Policy</NavLink></li>*/}
                                    <li><NavLink to={`/${i18n.language}/contact`}>{t('footer.contact')}</NavLink></li>
                                </ul>
                            </div>

                        </div>

                        {/*<div className='col footer-main__col footer-main__col--subscribe'>*/}
                        {/*    <div className=''>*/}
                        {/*        <div className='footer-subscribe'>*/}
                        {/*            <div className='footer-title'>{t('footer.GetInTouch')}</div>*/}
                        {/*            <div className='input-group'>*/}
                        {/*                <input className='form-control' disabled />*/}
                        {/*                <div className="input-group-append">*/}
                        {/*                    <button className="btn btn-subscribe" disabled={true} type="button">{t('footer.Subscribe')}<Arrow/></button>*/}
                        {/*                </div>*/}
                        {/*            </div>*/}
                        {/*        </div>*/}
                        {/*        <div className='footer-logo'>*/}
                        {/*            <Link to={`/${i18n.language}/`}><img src={LogoPng} alt='AutoRec'/></Link>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                    </div>
                </div>

                <div className='footer-copyrights'>
                    <div className='row align-items-center justify-content-center justify-content-md-between'>
                        <div className='col-auto copyrights'>{year} © Created by <a href='https://www.afternet.gr' target='_blank' rel="noopener noreferrer">Afternet</a></div>
                        <div className='col-auto footer-menu'>
                            {/*<ul>*/}
                            {/*    <li><NavLink to="/about-us">About us</NavLink></li>*/}
                            {/*    <li><NavLink to="/support">Support</NavLink></li>*/}
                            {/*    <li><NavLink to="/contact">Contact</NavLink></li>*/}
                            {/*</ul>*/}
                        </div>
                    </div>
                </div>
            </div>
            {/*<CookieBot domainGroupId={`${process.env.REACT_APP_COOKIE_BOT}`} language={i18n.language} />*/}
        </footer>
    );
};

export default Footer;
